import React from "react";
import { GrFormPreviousLink } from "react-icons/gr";
const FaqSideBar = props => {
  const handleCategorySelect = link => {
    props.onCategorySeclect(link);
  };

  return (
    <div className="sideBarWrapper">
      <div className="justify-content-center">
        <h5 className="faq-sideBar-title">دسته بندی پرسش ها</h5>
      </div>
      <hr />
      {props.links.map(link => (
        <div
          key={link.id || link.slug || link.value}
          className="faq-link"
          onClick={() => {
            handleCategorySelect(link);
          }}>
          <div>{link.value}</div>
          <GrFormPreviousLink className="category-link-icon faq-q-icon" />
        </div>
      ))}
    </div>
  );
};

export default FaqSideBar;
